import { PASSWORD_VALIDTION_LENGTH, PASSWORD_VALIDTION_NUMBER, PASSWORD_VALIDTION_UPPERCASE, PASSWORD_VALIDTION_LOWERCASE, PASSWORD_REQUIREMENT_LENGTH, PASSWORD_REQUIREMENT_NUMBER, PASSWORD_REQUIREMENT_UPPERCASE, PASSWORD_REQUIREMENT_LOWERCASE } from '../constants'
import type { UIPasswordValidationFieldType } from '../types'

/**
 * Validate password from rules
 *
 * @param password string
 */
export function passwordValidation(password: string, key?: UIPasswordValidationFieldType) {
    if (!password?.length) return { isValid: false }

    const validationMap = {
        [PASSWORD_VALIDTION_LENGTH]: PASSWORD_REQUIREMENT_LENGTH,
        [PASSWORD_VALIDTION_NUMBER]: PASSWORD_REQUIREMENT_NUMBER,
        [PASSWORD_VALIDTION_UPPERCASE]: PASSWORD_REQUIREMENT_UPPERCASE,
        [PASSWORD_VALIDTION_LOWERCASE]: PASSWORD_REQUIREMENT_LOWERCASE,
    }

    // If a key is provided, validate only the specified requirement
    if (key && validationMap[key]) {
        const testRegex = validationMap[key]

        return {
            isValid: testRegex.test(password),
            type: key,
        }
    }

    // If no key is provided, validate all requirements
    const isValid = Object.values(validationMap).every(regex => regex.test(password))

    return { isValid }
}
